const recoveryValidator = {

  password_old: {
    rules: [
      {
        test: (value) => {
          return value.length >= 6;
        },
        message: 'Password can not be < 6 characters',
      },
      {
        test: /^[a-z0-9A-Z_]+$/,
        message: 'Enter Valid Password',
      },
    ],
    errors: [],
    valid: false,
    state: ''
  },
  password_new: {
    rules: [
      {
        test: (value) => {
          return value.length >= 6;
        },
        message: 'Password can not be < 6 characters',
      },
      {
        test: /^[a-z0-9A-Z_]+$/,
        message: 'Enter Valid Password',
      },
    ],
    errors: [],
    valid: false,
    state: ''
  },
  isPasswordEqual: {
    rules: [
      {
        test: (value) => {
          return value.prev === value.next;
        },
        message: 'Passwords are not equal'
      },
    ],
    errors: [],
    valid: false,
    state: ''
  }
};

export default recoveryValidator;



// WEBPACK FOOTER //
// ./src/helpers/recoveryValidator.js